module.exports = __webpack_public_path__ + "img/graduate-gxifen-lecture.a71711cb.jpg";